// components
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, Button, MenuItem } from "@mui/material";
import TextField from "../../../utils/mui-rhf/TextField";
import Select from "../../../utils/mui-rhf/Select";
import MultiSelectV2 from "../../../components/mui-rhf/MultiselectV2";
// ----------------------------------------------------------------------

export default function RuleEdit({ currentRule, onSubmit, ruleTypes, options, sfhaOptions, nsfhaOptions, unitOptions, operandOptions, isNew }) {
  const methods = useForm();
  const { handleSubmit, setValue, setError, clearErrors, formState } = methods;
  const { errors } = formState;
  const [currentRuleType, setCurrentRuleType] = useState(null);
  const [currentFeatureType, setCurrentFeatureType] = useState(null);
  const [currentFloodzoneTypes, setCurrentFloodzoneTypes] = useState([]);
  const [selectedNsfhaOptions, setSelectedNsfhaOptions] = useState(() =>
    nsfhaOptions.filter((e) => currentFloodzoneTypes?.includes(e.value))
  );
  const [selectedSfhaOptions, setSelectedSfhaOptions] = useState(() =>
    sfhaOptions.filter((e) => currentFloodzoneTypes?.includes(e.value))
  );
  const submit = (values) => {
    onSubmit(values);
  };

  useEffect(() => {
    if (currentRule) {
      setCurrentRuleType(currentRule.ruleType);
        methods.reset();
        setValue("id", currentRule.id);
      setValue("title", currentRule.title);
      setValue("description", currentRule.description);
      setValue("ruleType", currentRule.ruleType);
      setValue("value", currentRule.value);
      setValue("unit", currentRule.unit);
      setValue("operand", currentRule.operand);
      setValue("featureTypeId", currentRule.featureType?.id);
      setValue("floodzoneTypeIds", currentRule.floodzoneTypeIds);
      setSelectedSfhaOptions(sfhaOptions.filter((e) => currentRule.floodzoneTypeIds?.includes(e.value)));
      setSelectedNsfhaOptions(nsfhaOptions.filter((e) => currentRule.floodzoneTypeIds?.includes(e.value)));
      setCurrentFloodzoneTypes(currentRule.floodzoneTypeIds ?? []);
      setCurrentFeatureType(currentRule.featureType?.id);
      setCurrentRuleType(currentRule.ruleType);
    }
  }, [currentRule, setValue]);

  useEffect(() => {
    
  }
  , [currentRuleType, currentFeatureType, currentFloodzoneTypes]);
  
  return (
    <div style={{ width: "100%" }}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submit)}>
          <Grid container spacing={2} padding={1}>
            <Grid item xs={12}>
              <TextField
                disabled={false}
                key={3}
                fullWidth
                label={"Title"}
                name={"title"}
                sx={{width: "100%"}}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                disabled={false}
                key={3}
                fullWidth
                label={"Description"}
                name={"description"}
                sx={{width: "100%"}}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                sx={{width: "100%"}}
                size="small"
                label={"Rule Type"}
                name={"ruleType"}
                value={currentRuleType}
                onChange={(e) => {
                  setValue("ruleType", e.target.value);
                  setCurrentRuleType(e.target.value);
                  clearErrors("ruleType");
                  if(e.target.value === "Contained By"){

                    setValue("value", null);
                    setValue("unit", null);
                    setValue("operand", null);
                  }
                }}
              >
                
                {ruleTypes.map((option, i) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
              </TextField>
              {errors && <span style={{ color: "red" }}>{errors.message}</span>}
            </Grid>
            {currentRuleType === "Proximity" && (
              <><Grid item xs={12}>
                <TextField
                  disabled={false}
                  key={3}
                  fullWidth
                  label={"Value"}
                  name={"value"}
                  sx={{ width: "100%" }} />
              </Grid><Grid item xs={12}>
                  <Select
                    options={unitOptions}
                    fullWidth
                    label={"Unit"}
                    name={"unit"}
                    rules={{ required: true }}
                    sx={{ width: "100%" }} />
                  {errors && <span style={{ color: "red" }}>{errors.message}</span>}
                </Grid><Grid item xs={12}>
                  <Select
                    options={operandOptions}
                    fullWidth
                    label={"Operand"}
                    name={"operand"}
                    rules={{ required: true }}
                    sx={{ width: "100%" }} />
                  {errors && <span style={{ color: "red" }}>{errors.message}</span>}
                </Grid></>
            )}
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                sx={{width: "100%"}}
                size="small"
                label={"Feature Type"}
                name={"featureTypeId"}
                value={currentFeatureType}
                onChange={(e) => {
                  setValue("floodzoneTypeIds", null);
                  setValue("featureTypeId", e.target.value);
                  setCurrentFloodzoneTypes(null);
                  clearErrors("featureTypeId");
                  setCurrentFeatureType(e.target.value);
                }}
              >
                
                {options.map((option, i) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
              </TextField>
              {errors && <span style={{ color: "red" }}>{errors.message}</span>}
            </Grid>
            <Grid item xs={12}>
            <MultiSelectV2
              options={sfhaOptions}
              label={"SFHA Type"}
              placeholder="SFHA Types"
              value={selectedSfhaOptions}
              onChange={(e) => {

                var hasAll = false;
                var currentlyHasAll = selectedSfhaOptions.filter((o) => o.label === "All SFHA").length > 0;
                if(!currentlyHasAll){
                  hasAll = e.some((o) => o.label === "All SFHA");;
                }

                var hasAllFloodways = false;
                var currentlyHasAllFloodways = selectedSfhaOptions.filter((o) => o.label === "All SFHA Floodways").length > 0;
                if(!currentlyHasAllFloodways){
                  hasAllFloodways = e.some((o) => o.label === "All SFHA Floodways");;
                }
                
                var newSelection = [];
                if(hasAllFloodways){
                  newSelection = sfhaOptions.filter((o) => o.label ===  "All SFHA Floodways");
                }else if(hasAll){
                  newSelection = sfhaOptions.filter((o) => o.label ===  "All SFHA");
                }else{  
                  newSelection = e.filter((o) => o.label !==  "All SFHA" && o.label !== "All SFHA Floodways");
                }
                

                setSelectedSfhaOptions(newSelection);
                setSelectedNsfhaOptions([]);
                setCurrentFloodzoneTypes(newSelection.map((o) => o.value));
                setValue("floodzoneTypeIds", newSelection.map((o) => o.value));
              }}
            />
              {/* <TextField
                select
                fullWidth
                sx={{width: "100%"}}
                size="small"
                label={"SFHA Type"}
                name={"floodzoneTypeIds"}
                value={currentFloodzoneType}
                onChange={(e) => {
                  setValue("featureTypeId", null);
                  setValue("floodzoneTypeId", e.target.value);
                  setCurrentFloodzoneType(e.target.value);
                  clearErrors("floodzoneTypeId");
                  setCurrentFeatureType(null);
                }}
              >
                
                {sfhaOptions.map((option, i) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
              </TextField> */}
              {errors && <span style={{ color: "red" }}>{errors.message}</span>}
            </Grid>
            
            
            <Grid item xs={12}>
            <MultiSelectV2
              options={nsfhaOptions}
              label={"NSFHA Type"}
              placeholder="NSFHA Types"
              value={selectedNsfhaOptions}
              onChange={(e) => {

                var hasAll = false;
                var currentlyHasAll = selectedNsfhaOptions.filter((o) => o.label === "All NSFHA").length > 0;
                if(!currentlyHasAll){
                  hasAll = e.some((o) => o.label === "All NSFHA");;
                }

                var hasAllFloodways = false;
                var currentlyHasAllFloodways = selectedNsfhaOptions.filter((o) => o.label === "All NSFHA Floodways").length > 0;
                if(!currentlyHasAllFloodways){
                  hasAllFloodways = e.some((o) => o.label === "All NSFHA Floodways");;
                }
                
                var newSelection = [];
                if(hasAllFloodways){
                  newSelection = nsfhaOptions.filter((o) => o.label ===  "All NSFHA Floodways");
                }else if(hasAll){
                  newSelection = nsfhaOptions.filter((o) => o.label ===  "All NSFHA");
                }else{  
                  newSelection = e.filter((o) => o.label !==  "All NSFHA" && o.label !== "All NSFHA Floodways");
                }
                

                setSelectedNsfhaOptions(newSelection);
                setSelectedSfhaOptions([]);
                setCurrentFloodzoneTypes(newSelection.map((o) => o.value));
                setValue("floodzoneTypeIds", newSelection.map((o) => o.value));
              }}
            />
              {/* <TextField
                select
                fullWidth
                sx={{width: "100%"}}
                size="small"
                label={"NSFHA Type"}
                name={"floodzoneTypeId"}
                value={currentFloodzoneType}
                onChange={(e) => {
                  setValue("featureTypeId", null);
                  setValue("floodzoneTypeId", e.target.value);
                  setCurrentFloodzoneTypes(e.target.value);
                  clearErrors("floodzoneTypeId");
                  setCurrentFeatureType(null);
                }}
              >
                
                {nsfhaOptions.map((option, i) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
              </TextField> */}
              {errors && <span style={{ color: "red" }}>{errors.message}</span>}
            </Grid>
          </Grid>
          <Button variant="contained" type="submit">
            Submit
          </Button>
        </form>
      </FormProvider>
    </div>
  );
}
